import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

const TitleLink = props => {
  const { classes, link, text } = props;
  if (!text) return null;
  if (!link) return <div className={classes}>{text}</div>;
  return (
    <Link to={link} className={classes}>
      {text}
    </Link>
  );
};

export default TitleLink;

TitleLink.defaultProps = {
  classes: null,
  link: null,
  text: null,
};

TitleLink.propTypes = {
  classes: PropTypes.shape({}),
  link: PropTypes.string,
  text: PropTypes.string,
};
